import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import StrategyAuth from './StrategyAuth.vue'
import useI18nTl from '@/hooks/useI18nTl'
import { computed } from 'vue'


import { defineComponent } from 'vue'

const __default__ = defineComponent({
  name: 'StrategyAuthDrawer',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  modelValue: {
    type: Boolean,
    required: true,
  },
  info: {
    type: Object,
    default: () => ({}),
  },
},
  emits: ['update:modelValue', 'submit', 'submitted'],
  setup(__props, { emit }) {

const props = __props



const { tl } = useI18nTl('Operation')


const showDialog = computed({
  get: () => props.modelValue,
  set: (val: boolean) => {
    emit('update:modelValue', val)
  },
})

return (_ctx: any,_cache: any) => {
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    title: _unref(tl)('strategyAuthMgr'),
    modelValue: _unref(showDialog),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(showDialog) ? (showDialog).value = $event : null)),
    "lock-scroll": false,
    "close-on-click-modal": true,
    size: "50%",
    "z-index": 1999,
    "custom-class": "evse-drawer",
    "destroy-on-close": true
  }, {
    default: _withCtx(() => [
      _createVNode(StrategyAuth, {
        strategyID: props.info.id,
        operatorID: props.info.operatorId
      }, null, 8, ["strategyID", "operatorID"])
    ]),
    _: 1
  }, 8, ["title", "modelValue"]))
}
}

})